import { CheckoutSession, FeePaymentType, Loan } from '@nemuru-eng/js-api-client';

import { CartSummaryMap } from '@/components/modules/_shared/CartSummary/maps/CartSummary.map';
import { FinancingLiveSummaryData } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/types/FinancingLiveSummaryData';
import { LoanInsuranceMap } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LoanConditions/maps/loanInsurance.map';

const EMPTY_FINANCING_SUMMARY: FinancingLiveSummaryData = {
  term: null,
  instalmentAmount: null,
  downPaymentAmount: null,
  principalAmount: null,
  discountAmount: null,
  annualInterest: null,
  insurance: null,
  insuranceProvider: null,
  setupFeeAmount: null,
  setupFeeType: null,
};

export const buildFinancingLiveSummaryData = ({
  checkoutSession,
  loan,
}: {
  checkoutSession: CheckoutSession;
  loan: Loan | undefined;
}): FinancingLiveSummaryData => {
  if (!loan) {
    return {
      ...EMPTY_FINANCING_SUMMARY,
      downPaymentAmount: checkoutSession.downPayment.amount.amount,
      discountAmount: CartSummaryMap.fromCheckoutSessionToCartSummaryData(checkoutSession).totalDiscount ?? 0,
    };
  }

  const displayInsurance = LoanInsuranceMap.fromLoan(loan);
  const setupFeeType = loan.loanConditions.loanCalculator.setupFee.type;
  const setupFeeAmount = loan.loanConditions.loanCalculator.setupFee.feeAmount?.amount ?? null;
  const merchantDiscountPercentage = loan.loanConditions.program.merchantDiscountPercentage ?? 0;
  const principalAmount = loan.loanConditions.principal.amount;
  const discountAmount =
    CartSummaryMap.fromCheckoutSessionToCartSummaryData(checkoutSession).totalDiscount ??
    principalAmount * merchantDiscountPercentage;

  return {
    term: loan.loanConditions.loanCalculator.term.period,
    instalmentAmount: loan.loanConditions.loanCalculator.userDefinedQuota?.amount ?? null,
    downPaymentAmount: checkoutSession.downPayment.amount.amount,
    principalAmount,
    discountAmount,
    annualInterest: loan.loanConditions.annualInterest ?? null,
    insurance: displayInsurance?.type ?? null,
    insuranceProvider: displayInsurance?.provider ?? null,
    setupFeeAmount,
    setupFeeType: Object.values(FeePaymentType).includes(setupFeeType as FeePaymentType) ? setupFeeType : null,
  };
};
